<div class="exchanger-switch"
     [class.disabled]="disabled"
     [class.theme-documents]="isDocumentsTheme()"
     [class.theme-images]="isImagesTheme()">
  <div class="exchanger-switch__instruction" *ngIf="!hasValue()">
    {{ getInstructionText() }}
  </div>
  <div class="exchanger-switch__content">
    <div class="exchanger-switch__dropdown"
         [class.disabled]="disabled"
         [class.open]="isDropdownMenuVisible()">
    <button class="exchanger-switch__dropdown-toggle"
            type="button"
            [attr.aria-expanded]="isDropdownMenuVisible()"
            [disabled]="disabled"
            (click)="toggleDropdown($event)">
      <mat-icon *ngIf="getSelectedOptionIcon()"
                class="exchanger-switch__selected-icon"
                aria-hidden="true">
        {{ getSelectedOptionIcon() }}
      </mat-icon>
      <mat-icon class="exchanger-switch__dropdown-icon"
                aria-hidden="true">
        arrow_drop_down
      </mat-icon>
      <span class="exchanger-switch__text">
        {{ getSelectedOptionLabel() }}
      </span>
    </button>
    <ul *ngIf="isDropdownMenuVisible()"
        class="exchanger-switch__dropdown-menu">
      <li *ngFor="let option of options"
          class="exchanger-switch__dropdown-item"
          [class.selected]="isSelected(option.value)"
          (click)="selectOption(option.value)">
        <mat-icon class="exchanger-switch__dropdown-item-icon"
                  aria-hidden="true">
          {{ option.icon }}
        </mat-icon>
        <span>{{ option.label }}</span>
      </li>
    </ul>
    </div>

    <div class="exchanger-switch__toggle"
       aria-label="Exchange direction"
       role="group">
    <button class="exchanger-switch__option"
            type="button"
            [attr.aria-pressed]="isActive('send')"
            [class.active]="isActive('send')"
            [disabled]="isToggleDisabled()"
            (click)="setMode('send')">
      {{ sendLabel }}
    </button>

    <button class="exchanger-switch__option"
            type="button"
            [attr.aria-pressed]="isActive('receive')"
            [class.active]="isActive('receive')"
            [disabled]="isToggleDisabled()"
            (click)="setMode('receive')">
      {{ receiveLabel }}
    </button>

    <span class="exchanger-switch__thumb"
          [class.send]="isActive('send')"
          [class.receive]="isActive('receive')"
          [class.neutral]="!hasValue()"></span>
    </div>
  </div>
</div>
